import { Order } from '../../../../../types/apiResponse/order';

// API values can be numeric strings despite the historical frontend contract.
export const text = (value: unknown): string => (value == null ? '' : String(value).trim());
export const number = (value: unknown): number | null => {
  if (!text(value)) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};
export const flag = (value: unknown): string => text(value).toLowerCase();
export const hasUser = (value: unknown): boolean => !!text(value) && number(value) !== 0;
export const reference = (description: unknown, code: unknown): string =>
  [text(description), text(code)].filter(Boolean).join(' · ');

export const validDate = (value: unknown): string => {
  const raw = text(value);
  if (!raw || /^0000-/.test(raw)) return '';
  return raw;
};

export function orderStatus(order: Order): 'cancelled' | 'approved' | 'pending' | 'unknown' {
  if (hasUser(order.CodigoUsuarioCancelamento)) return 'cancelled';
  if (hasUser(order.CodigoUsuarioLiberacao)) return 'approved';
  if (number(order.CodigoUsuarioLiberacao) === 0) return 'pending';
  return 'unknown';
}

export function erpStatus(order: Order): 'exported' | 'exportError' | 'notExported' | 'unknown' {
  const value = flag(order.erp_info?.ExportadoErp ?? order.ExportadoErp);
  if (value === 's') return 'exported';
  if (value === 'e') return 'exportError';
  if (value === 'n') return 'notExported';
  return 'unknown';
}
